/**
 * @module utils/Deferred
 * @description A Promise Class with externally exposed resolve and reject methods. It's then-able
 * and catch-able just like a regular Promise object. It can only be resolved or rejected once.
 * @see
 * https://stackoverflow.com/questions/26150232/resolve-javascript-promise-outside-function-scope
 * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Promise
 * @example
 * // Create one like a regular promise, then resolve/reject internally within the executor method.
 * const def = new Deferred((resolve, reject) => {
 *   resolve("value");
 * });
 * @example
 * // Create one without a executor method, and then resolve/reject externally, via method call.
 * const def = new Deferred();
 * def.resolve("value");
 * def.reject("error");
 */

/**
 * An externally resolvable Promise object.
 * @class
 */
export default class Deferred {
  constructor(executor) {
    this.promise = new Promise((resolve, reject) => {
      this.reject = reject;
      this.resolve = resolve;
      executor && executor(resolve, reject);
    });

    this.promise.resolve = this.resolve;
    this.promise.reject = this.reject;

    return this.promise;
  }
  // These class properties will prevent TSLint errors from appearing.
  // This Babel plugin is required: @babel/plugin-proposal-class-properties
  promise;
  all;
  catch;
  finally;
  race;
  reject;
  resolve;
  then;
}
